import {
    Alert,
    Box,
    Chip,
    CircularProgress,
    darken,
    lighten,
    Paper,
    Stack,
    Typography
} from '@mui/material'

import { BrandLogo } from 'ui-components/components/atoms/BrandLogo'
import { OtpInput } from 'ui-components/components/atoms/OtpInput'

export function ConfirmCodeForm(props) {
  const { email = 'name@company.com', render = [], slotProps } = props

  const length = slotProps?.OtpInput?.maxLength || 8

  return (
    <Paper
      square
      sx={{
        minHeight: '100vh'
      }}
    >
      <Stack
        spacing={3}
        p={3}
        justifyContent='center'
        alignItems='center'
        minHeight='50vh'
        {...slotProps?.Form}
        suppressHydrationWarning
      >
        <BrandLogo size='xl' />
        <Typography
          variant='next:h2'
          fontWeight={700}
          letterSpacing='tight'
          textAlign='center'
        >
          Check your email for a code
        </Typography>
        <Typography
          variant='next:subtitle1'
          textAlign='center'
        >
          We've sent you a {length}-character code to <b>{email}.</b> The code
          is expires shortly, so please enter it soon.
        </Typography>
        <OtpInput {...slotProps?.OtpInput} />
        {render.includes('warning') ? (
          <Alert
            severity='warning'
            variant='filled'
            action={
              <Chip
                label='Resend'
                color='warning'
                variant='filled'
                sx={{
                  bgcolor: (theme) => lighten(theme.palette.warning.main, 0.2)
                }}
                {...slotProps?.AlertWarn}
              />
            }
          >
            Your code has expired. Please request a new one.
          </Alert>
        ) : null}
        {render.includes('error') ? (
          <Alert
            severity='error'
            variant='filled'
            action={
              <Chip
                label='Resend'
                color='error'
                variant='filled'
                sx={{
                  bgcolor: (theme) => darken(theme.palette.error.main, 0.2)
                }}
                {...slotProps?.AlertError}
              />
            }
          >
            That code wasn't valid. Have another go!
          </Alert>
        ) : null}
        {render.includes('loading') ? (
          <Box component={CircularProgress}></Box>
        ) : null}
      </Stack>
    </Paper>
  )
}
